import {request} from './base'

export default {
    queryPage(params) {
        return request('/worker/queryPage', params, 'get')
    }
}
